<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :item-text="itemText"
    item-value="site_code"
    :label="label"
    :prepend-inner-icon="prependInnerIcon"
    :color="color"
    :background-color="backgroundColor"
    :search-input.sync="search"
    solo
    clearable
    hide-no-data
    hide-details
    cache-items
    return-object
  >
    <template v-slot:selection="{ item }">
      <span>{{ item['site_name'] }}</span>
    </template>

    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item['site_name'] }} ({{ data.item['site_code'] }})</v-list-item-title>
        <v-list-item-subtitle v-if="data.item['site_street'] && data.item['site_suburb']">
          {{ data.item['site_street'] + ', ' + data.item['site_suburb'] }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
    export default {
        name: "SchoolSwitcher",
        props: {
            items: {
                type: Array,
                default: () => []
            },
            label: {
                type: String,
                default: ""
            },
            prependInnerIcon: {
                type: String,
                default: "mdi-magnify"
            },
            color: {
                type: String,
                default: "#FFFFFF"
            },
            backgroundColor: {
                type: String,
                default: "#1A3B69"
            },
            searchInputHandler: {
                type: Function,
                required: true
            },
            setSelect: {
                type: Function,
                required: true
            },
        },
        data() {
            return {
                search: null,
                itemText:'site_code'
            };
        },
        computed: {
            select: {
                get(value) {
                    return value;
                },
                set(value) {
                    this.setSelect(value);
                }
            }
        },
        watch: {
            search(val) {
                if (val) {
                    if (isNaN(val)) {
                        this.itemText= 'site_name';
                    } else {
                        this.itemText= 'site_code';
                    }
                    this.searchInputHandler(val)
                 }
            },
        }
    }
</script>

<style scoped>

</style>
